<div
  role="group"
  attr.aria-labelledby="filterTitle-{{ filter.id }}"
  class="search-filter-sidebar"
>
  <!-- Checkbox Filter -->
  <ng-container *ngIf="isCheckboxFilter">
    <button
      type="button"
      id="filterTitle-{{ filter.id }}"
      class="filter--title filter--title-checkbox"
      attr.data-dgat="search-filter-sidebar-{{ filter.id }}"
      (click)="toggleCheckboxFilterSelected()"
      [ngClass]="{
        'filter--title-checkbox_selected': isCheckboxFilterSelected
      }"
    >
      <span class="h4">{{ filter.title | translate }}</span>
      <span class="l_flex l_flex-middle">
        <!-- Icon -->
        <df-icon
          *ngIf="icon"
          [icon]="icon.name"
          size="medium"
          class="guts-m-r-half {{ icon.class }}"
        ></df-icon>
        <!-- Count -->
        <span class="filter--title-checkbox_count" *ngIf="showCount">
          {{ contentCount }}
        </span>
        <!-- Checkbox -->
        <input
          tabindex="-1"
          readonly="readonly"
          [checked]="isCheckboxFilterSelected"
          type="checkbox"
          data-dgat="search-filter-sidebar-4f8"
        />
      </span>
    </button>
  </ng-container>

  <!-- Standard Filter -->
  <ng-container *ngIf="isStandardFilter">
    <button
      type="button"
      attr.aria-expanded="{{ isExpanded }}"
      id="filterTitle-{{ filter.id }}"
      class="filter--title"
      (click)="toggleFilterOptions()"
      attr.data-dgat="search-filter-sidebar-{{ filter.id }}"
    >
      <div class="l_flexbar l_flex-justify l_flex-middle">
        <div class="l_flex l_flex-middle">
          <div class="h4">{{ filter.title | translate }}</div>
          <div
            *ngIf="selectedOptionCount > 0"
            class="
              badge badge-pill badge-pill--compact
              badge-emphasize
              guts-m-l-half
            "
          >
            {{ selectedOptionCount }}
          </div>
        </div>
        <df-icon
          class="filter--title-icon"
          size="medium"
          [icon]="isExpanded ? 'chevron-up' : 'chevron-down'"
        ></df-icon>
      </div>
    </button>

    <!-- Filter Options -->
    <div *ngIf="isExpanded">
      <dgx-search-filter-sidebar-options
        class="full-width"
        [filter]="filter"
        (filterChange)="filterChange.emit($event)"
      ></dgx-search-filter-sidebar-options>
    </div>
  </ng-container>

  <!-- Range Filter -->
  <ng-container *ngIf="isRangeFilter">
    <dgx-search-filter-range-sidebar
      [filter]="filter"
      (toggleFilter)="toggleFilterOptions()"
      [isExpanded]="isExpanded || !!selectedOptionCount"
      [selectedOptionCount]="selectedOptionCount"
      (filtersChanged)="filterChange.emit($event)"
    ></dgx-search-filter-range-sidebar>
  </ng-container>
</div>
